import React, { Component } from 'react';
import { navigate } from '@reach/router';
import { classname } from 'utils';
import { Image } from 'elements';
import tokens from '../../elements/Face/Face.tokens';

import '../BrandPassportPopup/BrandPassportPopup.css';

const STORAGE_KEY = 'performanceServicesPopup';

export default class PerformancePopup extends Component {
  cl = classname('brand-passport-popup');

  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    if (!process.browser) return;

    if (this.shouldShowPopup()) {
      setTimeout(() => {
        this.setState({ isVisible: true });
      }, 1000);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isVisible !== this.state.isVisible) {
      if (this.state.isVisible) {
        document.documentElement.classList.add('popup-open');
      } else {
        document.documentElement.classList.remove('popup-open');
      }
    }
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('popup-open');
  }

  shouldShowPopup = () => {
    const closedTimestamp = localStorage.getItem(STORAGE_KEY);

    if (!closedTimestamp) {
      return true;
    }

    const now = Date.now();
    const timePassed = now - parseInt(closedTimestamp, 10);
    const oneDayInMs = 24 * 60 * 60 * 1000;

    return timePassed >= oneDayInMs;
  };

  closePopup = () => {
    this.setState({ isVisible: false });
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  };

  handleClose = () => {
    this.closePopup();
  };

  handleOrderClick = () => {
    this.closePopup();
    navigate('/order');
  };

  render() {
    const { isVisible } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <div className={this.cl('overlay')}>
        <div className={this.cl('container')}>
          <button className={this.cl('close-button')} onClick={this.handleClose} aria-label="Закрыть попап">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.597656 1.10156L15.2711 15.7751" stroke="white" strokeWidth="1.68889" />
              <path d="M15.2734 0.59375L0.599944 15.2672" stroke="white" strokeWidth="1.68889" />
            </svg>
          </button>

          <div className={this.cl('content')}>
            <h2 className={this.cl('title')}>Узнайте, что&nbsp;ИИ знает про ваш бренд</h2>

            <p className={this.cl('description')}>
              Запишитесь на&nbsp;бесплатную консультацию от&nbsp;Nimax и&nbsp;получите индивидуальный план работы
              с&nbsp;GEO для вашего бизнеса.
            </p>

            <blockquote className={this.cl('quote')}>
              &laquo;Начните получать трафик с&nbsp;ИИ уже сейчас!&raquo;
            </blockquote>

            <div className={this.cl('bottom')}>
              <div className={this.cl('author')}>
                <div className={this.cl('author-avatar')}>
                  <Image
                    src="/peoples/girich/girich-round.png"
                    alt="Соня Гирич"
                    width={tokens.image.m}
                    height={tokens.image.m}
                    className={this.cl('author-photo')}
                  />
                </div>
                <div className={this.cl('author-info')}>
                  <div className={this.cl('author-name')}>Соня Гирич</div>
                  <div className={this.cl('author-title')}>Тимлид команды SEO</div>
                </div>
              </div>
              <button className={this.cl('cta-button')} onClick={this.handleOrderClick}>
                Получить план работы с&nbsp;GEO
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
